module.exports = __webpack_public_path__ + "static/media/combat(22).7380d9d2.PNG";